import { Tooltip } from '@montel/montelpro-shared-components-v2';
import { styled } from 'styled-components';

export const StyledProductIcon = styled.div<{
	$color: string;
	$textColor: string;
	$size: string;
	$fontSize: string;
}>`
	height: ${({ theme, $size }) => theme.spacing[$size] || $size};
	width: ${({ theme, $size }) => theme.spacing[$size] || $size};
	border-radius: 100%;
	font-weight: 700;
	font-size: ${({ theme, $fontSize }) =>
		theme.spacing[$fontSize] || $fontSize};
	display: flex;
	align-items: center;
	justify-content: center;

	color: ${({ theme, $textColor }) => theme.colors[$textColor] || $textColor};
	background-color: ${({ theme, $color }) => theme.colors[$color] || $color};
`;

export const StyledTooltip = styled(Tooltip)`
	margin-left: 0;
`;
